/* Clorofila: galería, packs que cambian la variante del formulario, botones que abren EasySell, carrusel y barra fija. */
(function () {
  'use strict';
  if (window.__clv) return;
  window.__clv = true;

  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function galeria() {
    $$('[data-clv-gal]').forEach(function (gal) {
      var main = gal.querySelector('.clv-gal-main');
      var thumbs = $$('.clv-gal-thumbs button', gal);
      var dots = $$('.clv-gal-dots span', gal);
      function marcar() {
        var i = Math.round(main.scrollLeft / Math.max(1, main.clientWidth));
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
      }
      thumbs.forEach(function (t, j) {
        t.addEventListener('click', function () { main.scrollTo({ left: j * main.clientWidth, behavior: 'smooth' }); });
      });
      main.addEventListener('scroll', marcar, { passive: true });
      marcar();
    });
  }

  /* Cada pack equivale a una oferta de cantidad de EasySell (mismo orden). El formulario se queda con la
     variante base; al abrirse EasySell se marca la oferta elegida y EasySell calcula el precio. */
  var ofertaElegida = 0;

  function packs() {
    var grupo = document.querySelector('[data-clv-packs]');
    if (!grupo) return;
    var precioBarra = document.querySelector('[data-clv-barra-precio]');
    var marcada = grupo.querySelector('input[type=radio]:checked');
    if (marcada) ofertaElegida = Number(marcada.getAttribute('data-oferta')) || 0;
    $$('input[type=radio]', grupo).forEach(function (r) {
      r.addEventListener('change', function () {
        $$('.clv-pack', grupo).forEach(function (p) { p.classList.toggle('is-sel', p.contains(r)); });
        ofertaElegida = Number(r.getAttribute('data-oferta')) || 0;
        if (precioBarra) {
          var t = r.closest('.clv-pack').querySelector('.clv-pack-t');
          precioBarra.textContent = (t ? t.firstChild.textContent.trim() + ' · ' : '') + r.getAttribute('data-precio');
        }
        marcarOferta();
        document.dispatchEvent(new CustomEvent('clv:oferta', { detail: { indice: ofertaElegida } }));
      });
    });
  }

  /* Marca en EasySell la oferta del pack elegido (espera hasta 4 s a que el formulario esté en pantalla) */
  function marcarOferta() {
    var intentos = 0;
    (function buscar() {
      var ofertas = $$('.es-quantity-offers .es-qo-container').filter(function (o) { return o.offsetParent !== null; });
      if (ofertas.length) {
        var o = ofertas[Math.min(ofertaElegida, ofertas.length - 1)];
        if (o) o.click();
        return;
      }
      if (++intentos < 40) setTimeout(buscar, 100);
    })();
  }

  function engancharEasySell() {
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.es-popup-button, #es-sticky, [data-clv-cta]')) marcarOferta();
    }, true);
  }

  /* Todos los botones abren el mismo formulario de pago al recibir que el buy-box */
  function comprar() {
    var es = document.querySelector('#clv-buybox .es-popup-button') || document.querySelector('.es-popup-button');
    if (es) { es.click(); return; }
    var btn = document.querySelector('#clv-buybox [type="submit"]');
    if (btn) { btn.click(); return; }
    var box = document.getElementById('clv-buybox');
    if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function barra() {
    var b = document.querySelector('[data-clv-barra]');
    var ancla = document.querySelector('#clv-buybox .clv-form');
    if (!b || !ancla || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      var on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      if (document.querySelector('#es-sticky')) on = false;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-hidden', on ? 'false' : 'true');
      var btn = b.querySelector('button');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }).observe(ancla);
  }

  function carruseles() {
    $$('[data-clv-carrusel]').forEach(function (w) {
      var fila = w.querySelector('.clv-razones-fila');
      $$('[data-dir]', w).forEach(function (b) {
        b.addEventListener('click', function () {
          var paso = fila.firstElementChild ? fila.firstElementChild.getBoundingClientRect().width + 16 : 260;
          fila.scrollBy({ left: paso * Number(b.getAttribute('data-dir')), behavior: 'smooth' });
        });
      });
    });
  }

  /* Videos: se reproducen en silencio solo cuando están en pantalla */
  function videos() {
    var vs = $$('[data-clv-video]');
    if (!vs.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.src && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { rootMargin: '120px' });
    vs.forEach(function (v) { io.observe(v); });
  }

  /* Reseñas del buy-box: puntos, avance automático cada 5 s y pausa al tocar */
  function opiniones() {
    $$('[data-clv-opis]').forEach(function (w) {
      var fila = w.querySelector('.clv-opis-fila');
      var dots = $$('.clv-opis-dots button', w);
      var n = fila.children.length, pausa = false;
      function actual() { return Math.round(fila.scrollLeft / Math.max(1, fila.clientWidth)); }
      function ir(i) { fila.scrollTo({ left: i * (fila.clientWidth + 12), behavior: 'smooth' }); }
      function marcar() { var i = actual(); dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); }); }
      dots.forEach(function (d, j) { d.addEventListener('click', function () { pausa = true; ir(j); }); });
      fila.addEventListener('scroll', marcar, { passive: true });
      ['touchstart', 'mouseenter'].forEach(function (ev) { fila.addEventListener(ev, function () { pausa = true; }, { passive: true }); });
      marcar();
      if (n > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setInterval(function () { if (!pausa && !document.hidden) ir((actual() + 1) % n); }, 5000);
      }
    });
  }

  function iniciar() {
    opiniones();
    galeria();
    packs();
    engancharEasySell();
    barra();
    carruseles();
    videos();
    $$('[data-clv-cta]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); comprar(); }); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
